import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";

// reactstrap components
import { Button, Row, Col, FormGroup, Input } from "reactstrap";

// services
import { showMessage, showQuestion } from "../../services/message.js";
import { api_POST, api_GET } from "../../services/api_service.js";
import { formateDateApi } from "../../helpers/formats";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";

//Context
import { useAuth } from "../../context/auth";

//Component
import InputPDF from "../../components/Input/InputPDF.jsx";
import ModalCancelamentoRequerimento from "../../components/ModalCancelamentoRequerimento/ModalCancelamentoRequerimento";

export default function AcoesGestor({ requerimento, handleReturn }) {
  const { session, setLoading, setupSistema } = useAuth();
  const [modalCancelamento, setModalCancelamento] = useState(false);
  const [optionAcaoConfirmaPagamentoTaxaFisLurb, setOptionAcaoConfirmaPagamentoTaxaFisLurb] = useState(null)

  const {
    register,
    handleSubmit,
    errors,
    setError,
    setValue,
    clearErrors,
    reset,
    getValues,
  } = useForm({ mode: "onBlur" });

  const [registro, set_registro] = useState(null);
  const [analiseRequerimento, setAnaliseRequerimento] = useState(false);

  useEffect(() => {
    set_registro(requerimento);
    ValidaAcessoFuncionalidadeAcao(
      "AnaliseRequerimento.Editar",
      function (result) {
        setAnaliseRequerimento(result);
      }
    );
    if (
      requerimento?.fluxoCadastroEtapaAtual?.tipo ==
      "Aguardando Enquadramento" ||
      requerimento?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Análise"
    )
      loadOptionsEnquadramento();
  }, []);

  // Enquadramento
  const [options_enquadramento, set_options_enquadramento] = useState([]);
  const [enquadramento, set_enquadramento] = useState(null);
  const loadOptionsEnquadramento = () => {
    api_GET("enquadramento")
      .then((result) => set_options_enquadramento(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleEnquadramento = (value) => {
    set_enquadramento(value);
    setValue("enquadramento", value, true);
    clearErrors("enquadramento");
  };

  const handleAguardandoAnalise = (aprovacao) => {
    if (
      (registro.setupSolicitacaoAcao.acao === "Novo Cadastro" ||
        registro.setupSolicitacaoAcao.acao === "Renovação") &&
      enquadramento == null &&
      registro.setupSolicitacaoAcao.enquadramentoObrigatorio
    ) {
      showMessage("Aviso", "Selecione o Enquadramento", "error", null);
      return;
    }

    let data = getValues();
    let json_submit = {
      requerimentoAnaliseGestor_Id: 0,
      requerimento_Id: registro.requerimento_Id,
      dataAnalise: formateDateApi(new Date()),
      usuarioAnalise_Id: session.usuario_Id,
      enquadramento_Id:
        enquadramento != null ? enquadramento.enquadramento_Id : null,
      aceite: aprovacao,
      observacao: data.observacao,
      codigoSistemaPrefeitura: data.codigoSistemaPrefeitura,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoAnaliseGestor", json_submit)
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAguardandoEnquadramento = () => {
    if (
      (registro.setupSolicitacaoAcao.acao == "Novo Cadastro" ||
        registro.setupSolicitacaoAcao.acao == "Renovação") &&
      enquadramento == null &&
      registro.setupSolicitacaoAcao.enquadramentoObrigatorio
    ) {
      showMessage("Aviso", "Selecione o Enquadramento", "error", null);
      return;
    }

    let data = getValues();
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      dataAnalise: formateDateApi(new Date()),
      usuarioAnalise_Id: session.usuario_Id,
      enquadramento_Id:
        enquadramento != null ? enquadramento.enquadramento_Id : null,
      observacao: data.observacao,
    };

    setLoading(true);
    api_POST(
      "AnaliseRequerimento/PostRequerimentoAnaliseEnquadramento",
      json_submit
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAguardandoAprovacao = (aprovacao) => {
    let data = getValues();
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      dataAprovacao: formateDateApi(new Date()),
      usuarioAprovacao_Id: session.usuario_Id,
      autorizado: aprovacao,
      observacao: data.observacao,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoAprovacao", json_submit)
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  // Certificado Curso - Somente para RSS
  const [anexoTaxaFisLurb, setAnexoTaxaFisLurb] = useState(null);
  const handleAnexoTaxaFisLurb = (_file, callback) => {
    if (_file == null) {
      showMessage(
        "Aviso",
        "Não foi possível concluir o anexo do arquivo.",
        "error",
        null
      );
      return;
    }
    setAnexoTaxaFisLurb(_file);
    callback();
  };

  const handleEnviarGuiaTaxa = async () => {
    if (!anexoTaxaFisLurb)
      return showMessage("Aviso", "É necessário anexar o comprovante da Taxa FISLURB.", "warning", null);

    if (!registro?.requerimentoTaxaFislurb || registro?.requerimentoTaxaFislurb.length === 0)
      return showMessage("Aviso", "Este requerimento não possui informações sobre a Taxa FISLURB.", "warning", null);

    const json_submit = {
      requerimentoTaxaFislurb_Id: registro.requerimentoTaxaFislurb[0].requerimentoTaxaFislurb_Id,
      requerimento_Id: registro.requerimentoTaxaFislurb[0].requerimento_Id,
      arquivoBase64: anexoTaxaFisLurb.base64,
      arquivo: anexoTaxaFisLurb.name,
      etapaAtual: registro?.fluxoCadastroEtapaAtual?.tipo,
      avancarEtapa: registro?.fluxoCadastroEtapaAtual?.tipo === "Anexar Guia Taxa" ? true : false
    };

    setLoading(true);

    try {
      await api_POST("AnaliseRequerimento/PostAnexoTaxaFisLurb", json_submit);
      showMessage(
        "Aviso",
        "Operação executada com sucesso!",
        "success",
        () => handleReturn()
      );
    } catch (err) {
      showMessage("Aviso", err.message || "Erro ao enviar os dados.", "error", null);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarPagamentoTaxaFisLurb = async () => {
    let data = getValues();

    if (!registro?.requerimentoTaxaFislurb || registro?.requerimentoTaxaFislurb.length === 0)
      return showMessage("Aviso", "Este requerimento não possui informações sobre a Taxa FISLURB.", "warning", null);

    if (!data?.dataPagamento)
      return showMessage("", "É necessário preencher a data pagamento taxa fisLurb!", "warning", null)

    let json_submit = {
      requerimentoTaxaFislurb_Id: registro.requerimentoTaxaFislurb[0].requerimentoTaxaFislurb_Id,
      requerimento_Id: registro.requerimentoTaxaFislurb[0].requerimento_Id,
      dataPagamento: data?.dataPagamento,
      usuarioConfirmacaoPagamento: session.usuario_Id,
    }

    setLoading(true);

    try {
      await api_POST("AnaliseRequerimento/PostPagamentoTaxaFisLurb", json_submit);
      showMessage(
        "Aviso",
        "Operação executada com sucesso!",
        "success",
        () => handleReturn()
      );
    } catch (err) {
      showMessage("Aviso", err.message || "Erro ao enviar os dados.", "error", null);
    } finally {
      setLoading(false);
    }
  }

  const handleAguardandoCompensacao = () => {
    api_GET(
      "AnaliseRequerimento/AtualizaStatusCobranca/" + registro.requerimento_Id
    )
      .then((result) => {
        if (result.data) {
          showMessage("Aviso", "Pagamento Confirmado!", "success", function () {
            handleReturn();
          });
        } else {
          showMessage(
            "Aviso",
            "O pagamento ainda não foi confirmado!",
            "success",
            null
          );
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAguardandoDiarioOficial = () => {
    let data = getValues();
    if (data.dataPublicacao == "") {
      showMessage("Aviso", "Informe a data de publicação!", "error", null);
      return;
    }
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      usuarioPublicacao_Id: session.usuario_Id,
      dataPublicao: formateDateApi(data.dataPublicacao),
      requerimentoLaudaDiarioOficial_Id: 0,
    };

    setLoading(true);
    api_POST(
      "AnaliseRequerimento/PostRequerimentoPublicacaoDiarioOficial",
      json_submit
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAguardandoFiscalizacao = (aprovacao) => {
    let data = getValues();
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      dataFiscalizacao: formateDateApi(new Date()),
      usuarioFiscalizacao_Id: session.usuario_Id,
      autorizado: aprovacao,
      observacao: data.observacao,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoFiscalizacao", json_submit)
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleCancelarRequerimento = () => {
    setModalCancelamento(true);
  };

  const handleEmitirGuia = () => {
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      usuarioEmissao_Id: session.usuario_Id,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoCobranca", json_submit)
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleAprovacaoGuia = (aprovacao) => {
    let data = getValues();
    let json_submit = {
      requerimento_Id: registro.requerimento_Id,
      dataAprovacao: formateDateApi(new Date()),
      usuarioAprovacao_Id: session.usuario_Id,
      aprovado: aprovacao,
      observacao: data.observacao,
    };

    setLoading(true);
    api_POST(
      "AnaliseRequerimento/PostRequerimentoAprovacaoPagamento",
      json_submit
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleEmailCobranca = () => {
    setLoading(true);
    api_GET(
      `AnaliseRequerimento/ReenviarCobrancaEmail/${requerimento.requerimento_Id}`
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleEmailAgendamentoVistoria = () => {
    setLoading(true);
    api_GET(
      `AnaliseRequerimento/ReenviarAgendamentoVistoriaEmail/${requerimento.requerimento_Id}`
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleBaixaManual = () => {
    setLoading(true);
    api_POST(
      `AnaliseRequerimento/BaixaManualBoletoRequerimento/${requerimento.requerimento_Id}/${session.usuario_Id}`
    )
      .then((result) => {
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          function () {
            handleReturn();
          }
        );
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <ModalCancelamentoRequerimento
        visibilidadeModal={modalCancelamento}
        setVisibilidadeModal={() => setModalCancelamento(false)}
        item={registro}
        onConfirmar={(motivo, fechar) => {
          showQuestion('Atenção', 'Deseja cancelar este requerimento?', 'question', function (result) {
            if (result) {
              let usuario_Id = session != null && session.tipoAcesso === "AreaRestrita" ? session.usuario_Id : 0;
              setLoading(true);
              api_POST(`requerimento/PostCancelaRequerimento/${registro.requerimento_Id}/` + usuario_Id, { justificativaCancelamento: motivo })
                .then(() => {
                  fechar();
                  showMessage("Aviso", "Requerimento cancelado com sucesso!", "success", function () { handleReturn(); });
                })
                .catch((err) => showMessage("Aviso", err.message, "error", null))
                .finally(() => setLoading(false));
            }
          });
        }}
      />
      {analiseRequerimento && (
        <div>
          {registro != null &&
            (registro.status == "Pendente" ||
              registro.status == "Em Andamento" ||
              registro.status == "Divergente") &&
            registro?.fluxoCadastroEtapaAtual?.tipo !=
            "Aguardando Compensação" &&
            registro?.fluxoCadastroEtapaAtual?.tipo != "Vistoria" && (
              <div>
                <h3 className="titulo-consulta">Ação</h3>
                <div className="line-protocolo"></div>
              </div>
            )}

          {registro != null &&
            (registro.status == "Pendente" ||
              registro.status == "Em Andamento" ||
              registro.status == "Divergente") &&
            registro?.setupSolicitacaoAcao?.cancelarRequerimentos == true && (
              <Row className="px-2">
                <Button
                  color="danger"
                  onClick={() => handleCancelarRequerimento()}
                  className="btn-mobile"
                  type="button"
                >
                  Cancelar Requerimento
                </Button>
              </Row>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Análise" && (
              <div>
                {registro.setupSolicitacaoAcao.enquadramentoObrigatorio &&
                  !(
                    registro.setupSolicitacaoAcao.acao == "Cancelamento" &&
                    registro.setupSolicitacaoAcao.setupSolicitacao.categoria
                      .sigla == "RGG" &&
                    registro.setupSolicitacaoAcao.setupSolicitacao.segmento ==
                    "Grande Gerador"
                  ) && (
                    <Row className="mt-2">
                      <Col lg="6">
                        <FormGroup>
                          <b>
                            <label>
                              <span className="text-danger">*</span> Selecione o
                              Enquadramento
                            </label>
                          </b>
                          <Select
                            options={options_enquadramento}
                            name="enquadramento"
                            getOptionLabel={(option) => option.descricao}
                            getOptionValue={(option) => option.enquadramento_Id}
                            onChange={(e) => {
                              handleEnquadramento(e);
                            }}
                            value={
                              enquadramento != null &&
                              options_enquadramento.find(
                                (obj) =>
                                  obj.enquadramento_Id ===
                                  enquadramento.enquadramento_Id
                              )
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "enquadramento" },
                                { required: true }
                              )
                            }
                          />
                          {errors.enquadramento && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                {(registro.setupSolicitacaoAcao.acao == "Novo Cadastro" ||
                  registro.setupSolicitacaoAcao.acao == "Renovação") &&
                  setupSistema &&
                  setupSistema.informarCodigoSistemaPrefeitura && (
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <b>
                            <label> Código Processo de Credenciamento</label>{" "}
                          </b>
                          <Input
                            type="text"
                            name="codigoSistemaPrefeitura"
                            innerRef={register({ required: true })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <b>
                        <label> Observação</label>{" "}
                      </b>
                      <Input
                        type="textarea"
                        name="observacao"
                        innerRef={register()}
                        style={{ resize: "both", maxHeight: "500px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={() => handleAguardandoAnalise(true)}
                      className="btn-mobile"
                      type="button"
                    >
                      Aprovar
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleAguardandoAnalise(false)}
                      className="btn-mobile"
                      type="button"
                    >
                      Reprovar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Aprovação" && (
              <div>
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <b>
                        <label> Observação</label>{" "}
                      </b>
                      <Input
                        type="text"
                        name="observacao"
                        innerRef={register()}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={() => handleAguardandoAprovacao(true)}
                      className="btn-mobile"
                      type="button"
                    >
                      Aprovar
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleAguardandoAprovacao(false)}
                      className="btn-mobile"
                      type="button"
                    >
                      Reprovar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Anexar Guia Taxa" && (
              <div>
                <Row className="d-flex justify-content-start align-items-center mt-2">
                  <Col lg="12" >
                    <FormGroup>
                      <b>
                        <label>Anexar o documento da taxa</label>
                      </b>
                      <br />
                      <InputPDF
                        name="taxaFisLurb"
                        image={anexoTaxaFisLurb}
                        height="5rem"
                        width="5rem"
                        documento_id={0}
                        handlefile={handleAnexoTaxaFisLurb}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12" >
                    {anexoTaxaFisLurb?.base64 && (
                      <Button
                        color="link"
                        onClick={() => {
                          const byteCharacters = atob(anexoTaxaFisLurb.base64);
                          const byteNumbers = new Array(byteCharacters.length);
                          for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                          }
                          const byteArray = new Uint8Array(byteNumbers);
                          const blob = new Blob([byteArray], { type: "application/pdf" });
                          const blobUrl = URL.createObjectURL(blob);

                          const link = document.createElement("a");
                          link.href = blobUrl;
                          link.target = "_blank";
                          link.click();

                          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                        }}
                      >
                        📄 Visualizar documento da taxa
                      </Button>
                    )}
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={handleEnviarGuiaTaxa}
                      className="btn-mobile"
                      type="button"
                    >
                      Enviar Anexo Guia Taxa
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {/* Solicitar Fiscalização */}
          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Compensação" &&
            setupSistema &&
            setupSistema.metodologiaCobranca == "Integração PRODAM" && (
              <div>
                <Row>
                  <Col lg="12">
                    <Button
                      color="info"
                      onClick={() => handleAguardandoCompensacao()}
                      className="btn-mobile"
                      type="button"
                    >
                      Atualizar Cobranças
                    </Button>
                    <Button
                      color="warning"
                      onClick={() => handleBaixaManual()}
                      className="btn-mobile"
                      type="button"
                    >
                      Confirmar baixa manual
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Diário Oficial" && (
              <div>
                <Row>
                  <Col lg="3" md="4" sm="12">
                    <FormGroup>
                      <b>
                        <label> Data Publicação</label>{" "}
                      </b>
                      <Input
                        type="date"
                        name="dataPublicacao"
                        innerRef={register({ required: true })}
                      />
                      {errors.dataPublicacao && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={() => handleAguardandoDiarioOficial()}
                      className="btn-mobile"
                      type="button"
                    >
                      Confirmar Publicação
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Fiscalização" && (
              <div>
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <b>
                        <label> Observação</label>{" "}
                      </b>
                      <Input
                        type="textarea"
                        name="observacao"
                        innerRef={register()}
                        style={{ resize: "both", maxHeight: "500px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={() => handleAguardandoFiscalizacao(true)}
                      className="btn-mobile"
                      type="button"
                    >
                      Aprovar
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleAguardandoFiscalizacao(false)}
                      className="btn-mobile"
                      type="button"
                    >
                      Reprovar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo == "Emissão de Guia" &&
            setupSistema &&
            setupSistema.metodologiaCobranca == "Integração PRODAM" && (
              <div>
                <Row>
                  <Col lg="12">
                    {registro.requerimentoCobrancas.length > 0 && (
                      <Button
                        color="info"
                        onClick={() => handleAguardandoCompensacao()}
                        className="btn-mobile"
                        type="button"
                      >
                        Atualizar Cobranças
                      </Button>
                    )}
                    <Button
                      color="warning"
                      onClick={() => handleBaixaManual()}
                      className="btn-mobile"
                      type="button"
                    >
                      Confirmar baixa manual
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => handleEmitirGuia()}
                      className="btn-mobile"
                      type="button"
                    >
                      Emitir Guia
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Aprovação de Guia" && (
              <>
                {(registro.setupSolicitacaoAcao.acao !== "Taxa FisLurb" &&
                  !registro?.requerimentoTaxaFislurb &&
                  registro?.requerimentoTaxaFislurb.length === 0) &&
                  <div>
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <b>
                            <label> Observação</label>{" "}
                          </b>
                          <Input
                            type="textarea"
                            name="observacao"
                            innerRef={register()}
                            style={{ resize: "both", maxHeight: "500px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Button
                          color="success"
                          onClick={() => handleAprovacaoGuia(true)}
                          className="btn-mobile"
                          type="button"
                        >
                          {" "}
                          Aprovar
                        </Button>
                        <Button
                          color="danger"
                          onClick={() => handleAprovacaoGuia(false)}
                          className="btn-mobile"
                          type="button"
                        >
                          Reprovar
                        </Button>
                      </Col>
                    </Row>
                  </div>
                }

                {(
                  registro.setupSolicitacaoAcao.acao === "Taxa FisLurb" &&
                  !!registro?.requerimentoTaxaFislurb &&
                  registro?.requerimentoTaxaFislurb.length > 0
                ) &&
                  <>
                    <Row className="mt-2">
                      <Col lg="4">
                        <FormGroup>
                          <b>
                            <label>Selecione a ação</label>
                          </b>
                          <Select
                            options={[
                              { value: "Confirmar pagamento Taxa FisLurb", label: "Confirmar pagamento Taxa FisLurb" },
                              { value: "Enviar Anexo Guia Taxa", label: "Enviar Anexo Guia Taxa" },
                            ]}
                            name="optionAcaoConfirmaPagamentoTaxaFisLurb"
                            value={[
                              { value: "Confirmar pagamento Taxa FisLurb", label: "Confirmar pagamento Taxa FisLurb" },
                              { value: "Enviar Anexo Guia Taxa", label: "Enviar Anexo Guia Taxa" },
                            ].find(
                              (obj) => obj.value === optionAcaoConfirmaPagamentoTaxaFisLurb
                            )}
                            onChange={(value) => setOptionAcaoConfirmaPagamentoTaxaFisLurb(value.value)}
                            placeholder="Selecione"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className="d-flex flex-wrap mt-2 align-items-stretch">
                      {optionAcaoConfirmaPagamentoTaxaFisLurb === "Enviar Anexo Guia Taxa" && (
                        <div className="d-flex flex-column mr-2">
                          <FormGroup className="d-flex flex-column flex-grow-1 mr-2">
                            <label className="fw-bold">Anexar Nova Guia</label>

                            <div className="d-flex flex-column mt-2">
                              <InputPDF
                                name="taxaFisLurb"
                                image={anexoTaxaFisLurb}
                                height="5rem"
                                width="5rem"
                                documento_id={0}
                                handlefile={handleAnexoTaxaFisLurb}
                              />

                              {anexoTaxaFisLurb?.base64 && (
                                <Button
                                  color="link"
                                  className="p-2 mt-1 text-start"
                                  onClick={() => {
                                    const byteCharacters = atob(anexoTaxaFisLurb.base64);
                                    const byteNumbers = new Array(byteCharacters.length);
                                    for (let i = 0; i < byteCharacters.length; i++) {
                                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    }
                                    const byteArray = new Uint8Array(byteNumbers);
                                    const blob = new Blob([byteArray], { type: "application/pdf" });
                                    const blobUrl = URL.createObjectURL(blob);

                                    const link = document.createElement("a");
                                    link.href = blobUrl;
                                    link.target = "_blank";
                                    link.click();

                                    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                                  }}
                                >
                                  📄 Visualizar documento da taxa
                                </Button>
                              )}
                            </div>

                            {/* Botão alinhado no rodapé */}
                            <div className="mt-auto">
                              <Button
                                color="warning"
                                onClick={handleEnviarGuiaTaxa}
                                className="btn-mobile"
                                type="button"
                              >
                                Enviar Anexo Guia Taxa
                              </Button>
                            </div>
                          </FormGroup>
                        </div>
                      )}

                      {/* Confirmar Pagamento */}
                      {optionAcaoConfirmaPagamentoTaxaFisLurb === "Confirmar pagamento Taxa FisLurb" && (
                        <div className="d-flex flex-column">
                          <FormGroup className="d-flex flex-column flex-grow-1">
                            <label className="fw-bold">Data Pagamento Taxa FisLurb</label>

                            <div className="mt-2">
                              <Input
                                type="date"
                                name="dataPagamento"
                                innerRef={register({ required: true })}
                              />
                            </div>

                            {errors.dataPagamento && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}

                            {/* Botão alinhado no rodapé */}
                            <div className="mt-auto">
                              <Button
                                color="success"
                                onClick={handleConfirmarPagamentoTaxaFisLurb}
                                className="btn-mobile"
                                type="button"
                              >
                                Confirmar pagamento Taxa FisLurb
                              </Button>
                            </div>
                          </FormGroup>
                        </div>
                      )}
                    </div>
                  </>

                }
              </>

            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Compensação" && (
              <div>
                <Row>
                  <Col lg="12">
                    <Button
                      color="secondary"
                      onClick={() => handleEmailCobranca()}
                      className="btn-mobile"
                      type="button"
                    >
                      Reenviar Email de Cobrança
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo == "Vistoria" && (
              <div>
                <Row>
                  <Col lg="12">
                    <Button
                      color="warning"
                      onClick={() => handleEmailAgendamentoVistoria()}
                      className="btn-mobile"
                      type="button"
                    >
                      Reenviar Email de Agendamento
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {registro != null &&
            registro.status == "Pendente" &&
            registro?.fluxoCadastroEtapaAtual != null &&
            registro?.fluxoCadastroEtapaAtual?.tipo ==
            "Aguardando Enquadramento" && (
              <div>
                {registro.setupSolicitacaoAcao.enquadramentoObrigatorio && (
                  <Row className="mt-2">
                    <Col lg="6">
                      <FormGroup>
                        <b>
                          <label>
                            <span className="text-danger">*</span> Selecione o
                            Enquadramento
                          </label>
                        </b>
                        <Select
                          options={options_enquadramento}
                          name="enquadramento"
                          getOptionLabel={(option) => option.descricao}
                          getOptionValue={(option) => option.enquadramento_Id}
                          onChange={(e) => {
                            handleEnquadramento(e);
                          }}
                          value={
                            enquadramento != null &&
                            options_enquadramento.find(
                              (obj) =>
                                obj.enquadramento_Id ===
                                enquadramento.enquadramento_Id
                            )
                          }
                          placeholder="Selecione"
                          ref={(e) =>
                            register(
                              { name: "enquadramento" },
                              { required: true }
                            )
                          }
                        />
                        {errors.enquadramento && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <b>
                        <label> Observação</label>{" "}
                      </b>
                      <Input
                        type="textarea"
                        name="observacao"
                        innerRef={register()}
                        style={{ resize: "both", maxHeight: "500px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <Button
                      color="success"
                      onClick={() => handleAguardandoEnquadramento()}
                      className="btn-mobile"
                      type="button"
                    >
                      Confirmar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
        </div>
      )}
    </>
  );
}
